<script setup lang="ts">
const emit = defineEmits<{
  (event: 'open-review'): void
}>()

defineProps<{
  avatarUrl?: string
  authorName?: string
  date?: string
  href?: string
}>()

const cardId = Math.random().toString(36).slice(2)
</script>

<template>
  <article class="public-review-card">
    <img class="public-review-card__avatar" :src="avatarUrl" />

    <div class="public-review-card__author">
      <span class="text-body mb-half" v-text="authorName" />
    </div>

    <span class="public-review-card__date" v-text="date" />

    <p class="public-review-card__body" :data-card="cardId"><slot /></p>

    <div class="public-review-card__actions">
      <a class="mr-1 public-review-card__expand-btn" :data-card="cardId" @click="emit('open-review')">
        Читать полностью
      </a>
      <a v-if="href" :href="href"> Подробнее </a>
    </div>
  </article>
</template>

<style lang="scss">
.public-review-card {
  height: auto;

  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: auto 1fr auto;
  gap: 12px 16px;
  grid-template-areas:
    'avatar author date'
    'body body body'
    'actions actions actions';

  width: min(90vw, 580px);
  height: 264px;

  padding: 16px;
  box-shadow: 0 1px 4px 0px #3a465d4b;
  border-radius: 16px;
  background: white;

  & > * {
    margin: 0;
  }

  &:last-child {
    margin-right: 48px;
  }

  &__avatar {
    grid-area: avatar;

    width: 48px;
    height: 48px;
    border-radius: 999px;
    object-fit: cover;
  }

  &__author {
    grid-area: author;
    align-self: center;
  }

  &__date {
    grid-area: date;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;

    color: $darkGray;
  }

  &__body {
    grid-area: body;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;

    word-wrap: break-word;
    overflow-wrap: anywhere;
    overflow: hidden;
    text-overflow: ellipsis;

    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 6;

    @include mobile {
      -webkit-line-clamp: 5;
      height: 112px;
    }
  }

  &__actions {
    grid-area: actions;

    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: $blue;

    text-align: right;
  }

  &__expand-btn:not([data-clamped]) {
    display: none;
  }
}
</style>
